import Vue from "vue";
import Router from "vue-router";
import LandingPage from "@/components/LandingPage";
import Accounts from "@/components/Accounts/Accounts";
import People from "@/components/People/People";
import Skills from "@/components/Skills/Skills";
import Groups from "@/components/Groups/Groups";
import Projects from "@/components/Projects/Projects";
import Roles from "@/components/Roles/Roles";

Vue.use(Router);

export default new Router({
	routes: [
		{
			path: "/",
			name: "Root",
			component: LandingPage
		},
		{
			path: "/LandingPage",
			name: "LandingPage",
			component: LandingPage
		},
		{
			path: "/skills",
			name: "Skills",
			component: Skills
		},
		{
			path: "/accounts",
			name: "Accounts",
			component: Accounts,
		},
		{
			path: "/people",
			name: "People",
			component: People,
		},
		{
			path: "/groups",
			name: "Groups",
			component: Groups,
		},
		{
			path: "/projects",
			name: "Projects",
			component: Projects,
		},
		{
			path: "/roles",
			name: "Roles",
			component: Roles,
		}
	],
	mode: "history"
});



// WEBPACK FOOTER //
// ./src/router/index.js